import { StyleSheet } from 'react-native'

const useStyles = (theme, isTablet) => StyleSheet.create({
  tabsInitialLayout: {
    flex: 1
  },
  tabs: {
    backgroundColor: theme.WHITE,
    width: isTablet ? 200 : '100%'
  },
  tabsIndicator: {
    backgroundColor: theme.AZTEC
  },
  scene: {
    alignItems: 'center',
    marginVertical: 20
  },
  buttonsContainer: {
    flex: 1,
    width: '100%',
    flexDirection: isTablet ? 'row' : 'column',
    justifyContent: 'space-between'
  },
  cancelButton: {
    marginRight: 20
  }
})

export default useStyles
